"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex-wrap flex-column text-left" };
const _hoisted_2 = ["value", "checked", "onChange"];
const vue_3 = require("vue");
const provider_1 = require("../../../../provider/provider");
const autoAI_1 = require("../model/autoAI");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIScheduleOptions',
    setup(__props) {
        const presenter = (0, vue_3.inject)(provider_1.autoAIPresenterInjectKey);
        const viewModel = (0, vue_3.inject)(provider_1.autoAIViewModelInjectKey);
        const options = [
            { value: autoAI_1.AutoAIScheduleMode.CREATE, label: "新しいシフトを作成" },
            { value: autoAI_1.AutoAIScheduleMode.EDIT_EXISTING, label: "既存のシフトを編集" },
            { value: autoAI_1.AutoAIScheduleMode.AGENT, label: "AIシフトエージェント" },
        ];
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(options, (option) => {
                    return (0, vue_2.createElementVNode)("label", {
                        key: option.value,
                        class: "oplus-form-radio"
                    }, [
                        (0, vue_2.createElementVNode)("input", {
                            type: "radio",
                            name: "auto-ai-schedule-mode",
                            value: option.value,
                            checked: (0, vue_2.unref)(viewModel)?.scheduleMode === option.value,
                            onChange: ($event) => ((0, vue_2.unref)(presenter)?.setScheduleMode(option.value))
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
                        _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(option.label), 1 /* TEXT */)
                    ]);
                }), 64 /* STABLE_FRAGMENT */))
            ]));
        };
    }
});
